import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import "toastr/build/toastr.min.css";
import { Card, CardBody, Input } from "reactstrap";

import { getOrderMessageHistory } from "../../store/order-message-history/actions";

import OrderMessageHistoryTable from "../../containers/order-message-history/OrderMessageHistoryTable";

class OrderMessageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pageSize: 10,
      modalAddIsOpen: false,
      modalEditIsOpen: false,
      modalConfirmDeleteIsOpen: false,
    };
  }

  toggleModalAdd = () => {
    this.setState(prevState => ({
      modalAddIsOpen: !prevState.modalAddIsOpen,
    }));
  };

  componentDidMount() {
    const { orderId, getOrderMessageHistory } = this.props;
    getOrderMessageHistory({
      page: 1,
      pageSize: 10,
      term: "",
      orderId,
    });
  }

  handleOnChangePage = page => {
    const { orderId, getOrderMessageHistory } = this.props;
    const { pageSize } = this.state;
    getOrderMessageHistory({ orderId, page, pageSize });
    this.setState({
      currentPage: page,
    });
  };

  handleOnPageSizeChange = size => {
    const { orderId, getOrderMessageHistory } = this.props;
    getOrderMessageHistory({ orderId, page: 1, pageSize: size });
    this.setState({ pageSize: size });
  };

  handleOnSearch = e => {
    const { orderId, getOrderMessageHistory } = this.props;
    const { value } = e.target;
    getOrderMessageHistory({ term: value ?? "", orderId });

    this.setState({
      term: value ?? "",
    });
  };

  render() {
    const { pageSize, currentPage } = this.state;
    const { items, itemCount, pageCount, loading } = this.props;

    return (
      <>
        <>
          <Card className="mb-2">
            <CardBody>
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  <div className="search-box me-2 mb-2 d-inline-block">
                    <div className="position-relative">
                      <Input
                        type="text"
                        placeholder="Quick Search ..."
                        onChange={this.handleOnSearch}
                      ></Input>
                      <i className="fas fa-search search-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary m-1" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {items && (
                <Card>
                  <CardBody>
                    <OrderMessageHistoryTable
                      items={items}
                      itemCount={itemCount}
                      currentPage={currentPage}
                      totalPage={pageCount}
                      defaultPageSize={pageSize}
                      onChangePage={this.handleOnChangePage}
                      onPageSizeChange={this.handleOnPageSizeChange}
                    />
                  </CardBody>
                </Card>
              )}
            </>
          )}
        </>
      </>
    );
  }
}

OrderMessageList.propTypes = {
  message: PropTypes.object,
  items: PropTypes.array,
  item: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string,
  itemCount: PropTypes.number,
  pageCount: PropTypes.number,
  getOrderMessageHistory: PropTypes.func,
  orderId: PropTypes.string,
};

const mapStateToProps = ({ orderMessageHistory }) => {
  return orderMessageHistory;
};

export default withRouter(
  connect(mapStateToProps, {
    getOrderMessageHistory,
  })(OrderMessageList)
);
